import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ErrorLabel from "../error_label";
import { event } from "jquery";
import toast from "react-hot-toast";

const VerifyRegOtp = (props) => {
  const [passwordShown, setPasswordShown] = useState(false);
  const [otp, setOTP] = useState("123456");
  const [error, setError] = useState(null);

  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
    },
  });

  const verifyRegOTP = async (data) => {
    // if(data?.otp == data?.emailotp){
    //   data.otp = data?.otp
      data.type='register' 
      props.handleRegOtp(data);
  
  };

  return (
    <>
      <form
        noValidate
        autoComplete="off"
        onSubmit={handleSubmit(verifyRegOTP)}
      >
        <p className="lead fw-bold me-3 text-secondary mb-1">
        OTP is sent to your Mobile Number & Official Email ID
        </p>
        {/* OTP input */}
        <div className="form-outline mb-3">
          <label className="form-label" htmlFor="otp">
            Mobile OTP
          </label>
          <div className="">
            <input
              className="form-control form-control-lg"
              type="text"
              id="otp"
              name="otp"
              maxLength={6}
              onInput={(e) => {
                if (e.target.value.length > 6) {
                  e.target.value = e.target.value.slice(0, 6);
                }
              }}
              onChange={(event) => setOTP(event.target.value)}
              {...register("otp", {
                required: "This is required."
              } )}
            />
            {errors.otp && (
                            <ErrorLabel message={errors.otp?.message} />
                          )}
            <input type="hidden" name="code" value="axis"></input>
          </div>
          {error && <p>{error}</p>}
        </div>
        <div className="form-outline mb-3">
          <label className="form-label" htmlFor="emailotp">
           Email OTP
          </label>
          <div className="">
            <input
              className="form-control form-control-lg"
              type="text"
              id="emailotp"
              name="emailotp"
              maxLength={6}
              onInput={(e) => {
                if (e.target.value.length > 6) {
                  e.target.value = e.target.value.slice(0, 6);
                }
              }}
              onChange={(event) => setOTP(event.target.value)}
              {...register("emailotp", {
                required: "This is required."
              })}
            />
             {errors.emailotp && (
                            <ErrorLabel message={errors.emailotp?.message} />
                          )}
            <input type="hidden" name="code" value="axis"></input>
          </div>
          {error && <p>{error}</p>}
        </div>
        <div className="text-center text-lg-start mt-4">
          <button type="submit" className="btn btn-primary w-100">
            Verify OTP
          </button>
        </div>
      </form>
    </>
  );
};

export default VerifyRegOtp;
